import { Button, Card, CircularProgress, Grid, InputLabel, Tooltip } from '@material-ui/core';
import { InfoOutlined } from '@material-ui/icons';
import React, { useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';

import { addTipeAset } from '../../../../redux/actions/AsetInvestasiActions';

const TambahTipe = () => {
    const history = useHistory();
    const [submit, setSubmit] = useState(false);
    const [params, setParams] = useState({
        type_id:"",
        type_en:""
    });
    const handleChange = ({ target: { value, name } }) => {
        setParams((pref) => ({
            ...pref,
            [name]: value
        }));
    };
    const handleFormSubmit = () => {
        setSubmit(true);
        addTipeAset(params)
            .then(() => {
                showAlert('Data berhasil disimpan', true);
                setSubmit(false);
            })
            .catch((err) => {
                let error = err?.response?.data;
                showAlert(
                    Array.isArray(error?.data)
                        ? error?.data[0]
                        : 'Gagal menyimpan data, coba beberapa saat lagi',
                    false
                );
                setSubmit(false);
            });
    };
    const showAlert = (text, success) => {
        Swal.fire({
            title: success ? 'Berhasil' : 'Oopss!',
            text: text,
            imageUrl: `/assets/images/icons/${
                success ? 'ic_success' : 'ic_error'
            }.svg`,
            imageWidth: 92,
            imageHeight: 92,
            confirmButtonText: 'Ok',
            confirmButtonColor: '#0083E2'
        }).then((res) => {
            if (res.isConfirmed && success) {
                history.goBack();
            }
        });
    };
    return (
        <div className="m-sm-30">
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={11} md={12}>
                    <h3 className="fw-bold m-0">Tambah Tipe</h3>
                </Grid>
                <Grid item xs={11} md={12}>
                    <Card elevation={0} className="py-5 px-6 border-radius-0 ">
                        <ValidatorForm
                            onSubmit={handleFormSubmit}
                            className="w-full"
                        >
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="type_id"
                                        className="mb-4"
                                    >
                                        Tipe [ID]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="type_id"
                                        placeholder="Tipe"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="type_id"
                                        value={params.type_id || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Tipe terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <InputLabel
                                        htmlFor="type_en"
                                        className="mb-4"
                                    >
                                        Tipe [EN]{' '}
                                        <span className="text-danger">*</span>
                                        <Tooltip title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website" placement='top-start' arrow>
                                            <InfoOutlined fontSize='small' color='action'></InfoOutlined>
                                        </Tooltip>
                                    </InputLabel>
                                    <TextValidator
                                        id="type_en"
                                        placeholder="Tipe"
                                        className="w-full"
                                        variant="outlined"
                                        onChange={handleChange}
                                        type="text"
                                        name="type_en"
                                        value={params.type_en || ''}
                                        validators={['required']}
                                        errorMessages={[
                                            'Masukkan Tipe terlebih dahulu'
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid
                                        container
                                        spacing={2}
                                        justifyContent="flex-end"
                                        className="flex-column-reverse flex-md-row"
                                    >
                                        <Grid item xs={12} md={2}>
                                            <Button
                                                color="primary"
                                                className="text-primary w-full radius-6 text-capitalize py-2"
                                                disableElevation
                                                disabled={submit}
                                                onClick={() => history.goBack()}
                                            >
                                                Batal
                                            </Button> 
                                        </Grid>
                                        <Grid item xs={12} md={2}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                className="text-white w-full radius-6 text-capitalize py-2"
                                                disableElevation
                                                disabled={submit}
                                            >
                                                {submit ? (
                                                    <CircularProgress
                                                        color="primary"
                                                        size={25}
                                                    />
                                                ) : (
                                                    'Simpan'
                                                )}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default TambahTipe;
